<template>
  <div
    itemscope=""
    itemtype="http://schema.org/CommunicateAction"
    data-component="alert"
    data-component-params='{"selectors":{"close" : ".promoalert__close"}}'
    data-component-id="b38d721f-2841-4e38-a1c0-9a6612cba9a8"
  >
    <div
      class="promoalert__container promoalert__container--content container"
      data-dl-component=""
      data-dl-component-name="promoalert_copy"
      data-dl-component-type="bbva/pwebs/components/par/promoalert"
      id="content-promoalert_copy"
    >
      <div
        class="promoalert__base promoalert--simple-light promoalert--simple promoalert--withimg"
      >
        <span class="error">
          <img src="@/assets/img/1x/0info_icon.png" alt="" />
          <p>
            Te vamos a enviar un email para que puedas iniciar el trámite en
            ANSES. Luego te esperamos en tu sucursal BBVA más cercana, en la
            fecha que te informe el organismo.
          </p>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PromoAlert",
  components: {}
};
</script>

<style scoped>
@import "../../style/promoalert/large.css";
@import "../../style/promoalert/small.css";

span.error {
  margin-left: 16px;
  margin-top: 8px;
  display: block;
}

span > img,
span > p {
  display: inline-block;
  vertical-align: top;
}

span > img {
  width: 16px;
}

span > p {
  margin-left: 2px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: BentonSansBBVA-Light;
  font-size: 13px;
  line-height: 1.33;
  color: #121212;
  margin-right: 15px;
}
</style>
